import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Loading,
  ScreenMask,
  SetDefaultWarehouseDialog,
} from 'components/common';
import { LOADING_ICON_SIZE1, LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { RootState } from 'reducers';
import { getWarehouseCodeFromCache } from 'utils';
import PoInfo from './PoInfo';
import ScanPo from './ScanPo';

type CheckStep = 'poInfo' | 'scanPo' | 'scanLocaiton';

const DefaultStep = 'scanPo';
const StepList = ['poInfo', 'scanPo', 'scanLocaiton'];

const PoReceive = () => {
  const { useState } = React;
  const [currentPo, setCurrentPo] = useState<StringKAnyVPair>({});
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] = useState(false);
  const [dialogClosable, setDialogClosable] = React.useState(true);
  const [inited, setInited] = useState(false);
  const [lockScreen, setLockScreen] = useState(false);
  const [poList, setPoList] = useState<StringKAnyVPair[]>([]);
  const [step, setStep] = useState<CheckStep>(DefaultStep);
  const [selectedWarehouse, setSelectedWarehouse] = useState<StringKAnyVPair>({});

  const warehouseList = useSelector(
    (state: RootState) => state.admin.warehouses,
    shallowEqual
  );

  const gotoAnchor = (step: CheckStep) => {
    const newHash = `#${step}`;
    //const url = window.location.pathname + window.location.search + newHash;

    window.location.hash = newHash;
  };

  const onCheckoutPo = (po: StringKAnyVPair) => {
    console.log('sel', po);
    if (po.warehouseCode === selectedWarehouse.code) {
      setCurrentPo(po);
      gotoAnchor('poInfo');
    } else {
      Modal.confirm({
        cancelText: 'No',
        centered: true,
        content: 'PO warehouse doesn’t match your default warehouse, do you want to switch the warehouse?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Yes',
        onOk() {
          setDefaultWarehouseVisible(true);
        },
        //onCancel() { checkWarehouse(po); },
      });
    }
  };

  const openSetDefaultWarehouseDialog = (config: StringKAnyVPair) => {
    setDialogClosable(
      typeof config.closable === 'boolean' ? config.closable : true
    );
    setDefaultWarehouseVisible(true);
  };

  React.useEffect(() => {
    if (!inited) {
      const whid = Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY));

      if (!whid || (typeof whid === 'number' && !getWarehouseCodeFromCache(whid))) {
        openSetDefaultWarehouseDialog({ closable: false });
      }

      const wh = warehouseList.find(w => w.id === whid);

      if (wh) setSelectedWarehouse(wh);

      gotoAnchor(DefaultStep);
      setInited(true);
    }

    const handleHashChange = () => {
      const anchor = window.location.hash.trim().slice(1) || DefaultStep;

      if (StepList.indexOf(anchor) > -1) {
        //console.log('ch step', anchor);
        setStep(anchor as CheckStep);
      }
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [inited, warehouseList]);

  return (<>
    <div style={{ marginTop: 10 }}>
      {step === 'scanPo' && (
        <ScanPo
          onSelectPo={onCheckoutPo}
          poList={poList}
          setPoList={setPoList}
        />
      )}
      {step === 'poInfo' && (
        <PoInfo
          po={currentPo}
          setLockScreen={setLockScreen}
        />
      )}
    </div>
    {defaultWarehouseVisible && (
      <SetDefaultWarehouseDialog
        closable={dialogClosable}
        close={() => {
          setDefaultWarehouseVisible(false);
        }}
        visible={defaultWarehouseVisible}
      />
    )}
    {lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default PoReceive;
